import BaseStore from "@/v1/utils/BaseStore";

const initialState = {
  filters: [
    {
      key: "softwareName",
      title: "label.software",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "gameName",
      title: "label.games",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "ratio",
      title: "label.collection",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "version",
      title: "label.version",
      active: false,
      values: [],
      metadata: [],
    },
    {
      key: "quality",
      title: "label.quality",
      active: false,
      values: [],
      metadata: [],
    },
  ],
};
const store = new BaseStore("gameGallery", initialState);

export default store.reducer();
